'use client'
import Link from 'next/link'

import { cn } from '@/lib/utils'
import { Button, buttonVariants } from '@/registry/new-york/ui/button'
import { useSession } from 'next-auth/react'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/registry/new-york/ui/avatar'
import { useRouter } from 'next/navigation'
import * as React from 'react'
import { RootMobileNav } from '@/components/root-mobile-nav'
import { RootNav } from '@/components/root-nav'
import { UserState } from '@halfcall.cn/prisma'

interface RootHeaderProps {
  bg?: string
}

export function RootHeader({ bg }: RootHeaderProps) {
  const { data, status, update } = useSession()
  const router = useRouter()

  return (
    <header
      className={cn(
        bg
          ? `text-secondary ${bg} supports-[backdrop-filter]:${bg}/95 `
          : 'bg-[#242628] supports-[backdrop-filter]:bg-[#242628]/95 ',
        'sticky top-0 z-50 w-full backdrop-blur '
      )}
    >
      <div className={cn('container px-4 flex h-20 items-center')}>
        <RootNav bg={bg} />
        <RootMobileNav />
        <div
          className={cn(
            'flex flex-1 items-center justify-between space-x-0 md:justify-end'
          )}
        >
          <nav className={cn('flex items-center space-x-0')}>
            {status === 'authenticated' ? (
              <Button
                size={'icon'}
                variant={'ghost'}
                className={'h-12 w-12 rounded-full'}
                onClick={() => {
                  if (data?.user?.state === UserState.REGISTER) {
                    router.push('/extra')
                    return
                  }
                  router.push(`/dashboard`)
                }}
              >
                <Avatar className={'w-10 h-10 '}>
                  <AvatarImage src={data?.user?.image ?? ''} alt="@shadcn" />
                  <AvatarFallback>HD</AvatarFallback>
                </Avatar>
              </Button>
            ) : (
              <Link
                href={'/register'}
                className={cn(
                  buttonVariants({ variant: 'outline' }),
                  'h-10 w-24 rounded-md text-foreground'
                )}
              >
                登录 / 注册
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}
